// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ExpressionInput.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import React, { Component } from "react";

import Button from "./Izenda.Button";
import CalculatedField from "share/components/controls/calculatedField/Izenda.CalculatedField";
import calculatedFieldConstants from "logic/data/Izenda.CalculatedFieldConstants";
import constants from "logic/data/Izenda.ReportDesignerConstants";
import connect from "share/enhancers/Izenda.Connect";

@connect()
class ExpressionInput extends Component {
  static defaultProps = {
    rows: 5
  };

  constructor(props: any) {
    super(props);

    this.state = {
      calculatedPopupType: calculatedFieldConstants.TYPES.EDIT
    };

    const { value, fieldStore } = props;
    fieldStore.fillCalculatedFieldData(value.id, null, true);
  }

  renderButton() {
    const props = this.props;

    return <Button {...props} onClick={this.renderPopup} />;
  }

  renderContent() {
    const { rows, value: { expression } } = this.props;

    return (
      <textarea
        readOnly
        rows={rows}
        className="expression-content"
        value={expression || ""}
      />
    );
  }

  renderPopup = () => {
    const {
      loadValue,
      openPopup,
      fieldStore: { calculatedStore }
    } = this.props;
    const source = loadValue();
    const selectedDataSourceId = calculatedStore.expressionSelection.getSelectedDataSourceId();

    const details = {
      name: source.name,
      expression: source.expression,
      izendaDataType: source.izendaDataType,
      id: source.id
    };

    openPopup(CalculatedField, {
      store: calculatedStore,
      onClose: this.closeCalculatedPopup,
      type: this.state.calculatedPopupType,
      value: details,
      querySourceId: selectedDataSourceId,
      expressionConfig: constants.EXPRESSION_SELECTION.MIDDLE_FIELD
    });
  };

  render() {
    return (
      <div className="expression-input">
        {this.renderContent()}
        {this.renderButton()}
      </div>
    );
  }

  /**
   * When popup is closed
   * @param {any} calculatedData 
   */
  closeCalculatedPopup = (calculatedData: any) => {
    const { onChange } = this.props;
    if (calculatedData) {
      onChange && onChange({ value: calculatedData });
    }
  };
}

export default ExpressionInput;



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.ExpressionInput.js